import axios from 'axios'
import Vue from 'vue'
import AuthService from "@/service/AuthService";

export default class WhatChatService {
    authService = new AuthService();
    config = {
        headers: { Authorization: `Bearer ${this.authService.getUserBearerToken()}` }
    };
    // createConversation(conversation, users) {
    //     const data = {
    //         conversation: conversation,
    //         users: users
    //     };
    //     return axios.post(Vue.prototype.$whatchat + '/discussions', data);
    // }
    createConversation(conversation, users) {
        const data = {
            conversation: conversation,
            users: users
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/CreateWhatChat', data, this.config);
    }
    createAgentPlayerConversation(baseUserIds, baseUserNames) {
        const data = {
            baseUserIds: baseUserIds,
            baseUserNames: baseUserNames
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/CreateAgentPlayerWhatChat', data, this.config);
    }
    getNegotiationsOngoing(baseUserId, startDate, endDate) {
        const data = {
            BaseUserId: baseUserId,
            StartDate: startDate,
            EndDate: endDate
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/GetNegotiationsOngoing', data, this.config);
    }
    getCountPendingMessagesToRead(baseUserId) {
        const data = {
            BaseUserId: baseUserId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/GetCountPendingMessagesToRead', data, this.config);
    }
    sendTocTocOnGroupChat(baseUserId) {
        const data = {
            BaseUserId: baseUserId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/SendTocTocOnGroupChat', data, this.config);
    }
    sendTocTocOnPrivateChat(baseUserId) {
        const data = {
            BaseUserId: baseUserId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Whatchat/SendTocTocOnPrivateChat', data, this.config);
    }
}